module.exports = __webpack_public_path__ + "img/message.313ffb6a.png";